module.exports = __webpack_public_path__ + "static/media/OpentheWindow.db0af2c3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/OpentheWindow.wav
// module id = 728
// module chunks = 0